module.exports = {
          srcSet: __webpack_public_path__ + "967b1774dc55b18fc7b750b0846a087d-24.png"+" 24w",
          images:[ {path: __webpack_public_path__ + "967b1774dc55b18fc7b750b0846a087d-24.png",width: 24,height: 43}],
          src: __webpack_public_path__ + "967b1774dc55b18fc7b750b0846a087d-24.png",
          toString:function(){return __webpack_public_path__ + "967b1774dc55b18fc7b750b0846a087d-24.png"},
          
          width: 24,
          height: 43
        }